export default __webpack_public_path__ + "static/media/volcano.f7d8491f.svg";